import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import KnowledgeBaseAppResource from './KnowledgeBaseAppResource';
import LandingPageAppResource from './LandingPageAppResource';
import LandingPageHomeSectionAppResource from './LandingPageHomeSectionAppResource';

class LandingPageHomeTopicOfInterestAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-home-topic-of-interest';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landing/page/home/topic/of/interest';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageUuid',
      'homeSectionUuid',
      'knowledgeBaseUuid',
      'knowledgeAssetUuid',
      'landingPage',
      'landingPageHome',
      'knowledgeBase',
      'filters',
      'location',
      'hasPropertyListings',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPage: LandingPageAppResource,
      landingPageHome: LandingPageHomeSectionAppResource,
      knowledgeBase: KnowledgeBaseAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      landingPage: 'landing_page_uuid',
      landingPageHome: 'home_section_uuid',
      knowledgeBase: 'knowledge_base_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      knowledgeBaseUuid: {
        type: 'string',
        presence: {
          message: "^Please select a Knowledge Base."
        },
      },
      knowledgeAssetUuid: {
        type: 'string',
        presence: {
          message: "^Please select an article or video to display."
        },
      },
      location: {
        type: 'object',
        presence: true,
      },
      filters: {
        type: 'object',
      },
      hasPropertyListings: {
        type: 'boolean',
      },
    };
  }
}

export default LandingPageHomeTopicOfInterestAppResource;
